import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Select, Spin } from 'antd';
import left from '@/assets/image/left.jpg';
import time from '@/assets/image/Vector.png';
import phoneIcon from '@/assets/image/phone-icon.png';
import logo from '@/assets/image/logo.png';
import FormSteps from './steps';
import formStore from 'store/form-submit';
//import front1 from '@/assets/fonts/GT-Walsheim-Pro-Black.woff';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { AxiosError } from 'axios';
import { ISteps, IBottom } from './form';

const { Option } = Select;

const FormReset = () => {
  const [defaultLang, setDefaultLang] = useState<string>('EN');
  const [steps, setSteps] = useState<ISteps[]>([]);
  const [bottom, setBottom] = useState<IBottom>({ elementEnScript: '', elementLocalScript: '' });
  const [header, setHeader] = useState<IBottom>({ elementEnScript: '', elementLocalScript: '' });
  const [contract, setContract] = useState<IBottom>({ elementEnScript: '', elementLocalScript: '' });
  const [phoneAreaCodes, setPhoneAreaCodes] = useState<string[]>([]);
  const [currencies, setCurrencies] = useState<string[]>([]);
  const [paramsData, setParamsData] = useState({});
  const [loading, setLoading] = useState<boolean>(true);
  const [addressData, setAddressData] = useState<any>([]);
  const history = useHistory();
  const { search } = useLocation();
  const { accessToken } = qs.parse(search);

  const signatures = async () => {
    try {
      await formStore.signatures({ accessToken });
      getConfig();
      getAddress();
    } catch (e) {
      history.push(`/form-submit/error?err_info=${(e as AxiosError).code}`);
    }
  };
  const getAddress = async () => {
    try {
      const {
        data: { data },
      } = await formStore.getAddress();
      setAddressData(data);
    } catch (e) {}
  };
  const getConfig = async () => {
    try {
      const {
        data: { data },
      } = await formStore.getConfig();
      setLoading(false);
      const { steps, bottom, header, configLanguage, contract } = data.template;
      const { currencies, phoneAreaCodes } = data;
      setPhoneAreaCodes(phoneAreaCodes);
      setCurrencies(currencies);
      setSteps(steps);
      setBottom(bottom);
      setHeader(header);
      setDefaultLang(configLanguage);
      setContract(contract);
    } catch (error) {}
  };

  useEffect(() => {
    signatures();
  }, []);

  const changeLang = (value: string) => {
    setDefaultLang(value);
  };

  const getParams = (value: any) => {
    setParamsData(Object.assign({}, value, paramsData));
  };
  const changeLoading = (value: boolean) => {
    setLoading(value);
  };

  return (
    <Wraper>
      <Spin spinning={loading}>
        <div className="content">
          <div className="left">
            <img src={left} alt="" />
          </div>
          <div className="right">
            <Select onChange={changeLang} className="select" defaultValue={defaultLang} style={{ width: 80 }}>
              <Option value="CN">中文</Option>
              <Option value="EN">英文</Option>
            </Select>
            <div className="header">
              <img src={logo} alt="" />
              <div
                dangerouslySetInnerHTML={{
                  __html: defaultLang === 'EN' ? header.elementEnScript : header.elementLocalScript,
                }}></div>
              <span className="limit-time">
                <img src={time} alt="" />5 minutes to finish
              </span>
            </div>
            <div className="form">
              <FormSteps
                currencies={currencies ?? []}
                phoneAreaCodes={phoneAreaCodes ?? []}
                contract={contract}
                paramsData={paramsData}
                getParams={getParams}
                defaultLang={defaultLang}
                steps={steps}
                addressData={addressData}
                changeLoading={changeLoading}
              />
            </div>
            <div className="bottom">
              <img src={phoneIcon} alt="" />
              <span
                dangerouslySetInnerHTML={{
                  __html: defaultLang === 'EN' ? bottom.elementEnScript : bottom.elementLocalScript,
                }}></span>
            </div>
          </div>
        </div>
      </Spin>
    </Wraper>
  );
};

const Wraper = styled.div`
  font-family: 'GT Walsheim Pro';
  width: 100%;
  height: 100%;
  overflow: hidden;
  .content {
    width: 100%;
    display: flex;
    .left {
      width: 38.2%;
      height: 100%;
      overflow: hidden;
      background-color: #ccc;
      img {
        width: 100%;
      }
    }
    .right {
      position: relative;
      width: 61.8%;
      max-height: 100vh;
      overflow-y: auto;
      .select {
        position: absolute;
        top: 2.4%;
        right: 2.7%;
      }
      .ant-select-selector {
        border-radius: 4px !important;
      }
      .header {
        margin-top: 7.3vh;
        margin-left: 2.7vw;
        p {
          width: 71.7%;
          font-size: 14px;
          line-height: 16px;
          color: #3e4459;
          margin-top: 10px;
        }
        h2 {
          font-size: 24px;
          line-height: 28px;
          margin-top: 3%;
          margin-bottom: 1.3%;
        }
        .limit-time {
          display: inline-block;
          width: 149px;
          font-size: 14px;
          height: 24px;
          line-height: 24px;
          background-color: #7acdaf;
          border-radius: 12px;
          color: #fff;
          img {
            margin: -2px 5px 0;
            vertical-align: middle;
          }
        }
      }
      .form {
        width: 50vw;
        margin-left: 2.7vw;
        margin-top: 34px;
        border: 1px solid #cfd2e3;
        border-radius: 10px;
      }
      .bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50vw;
        margin-left: 2.7vw;
        margin-top: 40px;
        margin-bottom: 40px;
        height: 36px;
        border: 1px solid #eaeaea;
        border-radius: 4px;
        color: #878d9c;
        img {
          margin-right: 10px;
        }
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    .right {
      width: 90vw !important;
      margin: 0 auto;
      .form {
        width: 100% !important;
        margin-left: 0 !important;
      }
      .bottom {
        width: 100% !important;
        margin-left: 0 !important;
      }
    }
    .left {
      display: none;
    }
  }
`;

export default FormReset;
